import {Fragment} from 'react'
import {EyeIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useLayoutRouteData} from '../../../../page-data/loaders/use-layout-route-data'
import {type StackPullRequest, useDownstackPendingReviewRequests} from './use-downstack-pending-review-request'

export function shouldShowStackReviewPreviousFirst(pullRequestsAwaitingReview: StackPullRequest[]): boolean {
  return pullRequestsAwaitingReview.length > 0
}

export function StackReviewPreviousFirst({variant}: {variant?: 'default' | 'embedded'}) {
  const {pullRequest, stack} = useLayoutRouteData()
  const {data: pullRequestsAwaitingReview} = useDownstackPendingReviewRequests(stack, pullRequest.number)

  if (!shouldShowStackReviewPreviousFirst(pullRequestsAwaitingReview)) return null

  const isPlural = pullRequestsAwaitingReview.length > 1
  const introText = isPlural ? 'Complete your requested reviews in' : 'Complete your requested review in'

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={EyeIcon} variant="warning" emphasized />}
      emphasizedLeadingVisual
      title={isPlural ? 'Review previous stacked PRs first' : 'Review a previous stacked PR first'}
      itemName="stack-review-previous-first"
      variant={variant}
      description={
        <>
          {introText}{' '}
          {pullRequestsAwaitingReview.map((pull, index) => {
            const separator =
              index === 0
                ? ''
                : index < pullRequestsAwaitingReview.length - 1
                  ? ', '
                  : pullRequestsAwaitingReview.length > 2
                    ? ', and '
                    : ' and '

            return (
              <Fragment key={pull.number}>
                {separator}
                <Link inline className="Link--inTextBlock" href={pull.url}>
                  #{pull.number}
                </Link>
              </Fragment>
            )
          })}{' '}
          before reviewing this pull request.
        </>
      }
    />
  )
}
